import { OnSpotAnswer, OnSpotQuestions } from '@/model/onSpot/OnSpot';

export const getAnswerFromReturnTreeAnswerId = (
    data: OnSpotQuestions | null,
    answerId: string
): OnSpotAnswer | null => {
    if (!data) {
        return null;
    }
    let answer: OnSpotAnswer | null = null;
    Object.keys(data).forEach((key) => {
        data[key].answers.forEach((a) => {
            if (a.id === answerId) {
                answer = a;
            }
        });
    });
    if (answer) {
        return answer;
    }
    return null;
};
